import { render, staticRenderFns } from "./ConfigRoleTask.vue?vue&type=template&id=32db5820"
import script from "./ConfigRoleTask.vue?vue&type=script&lang=js"
export * from "./ConfigRoleTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports